import { render, staticRenderFns } from "./confirm-modal.vue?vue&type=template&id=2d705c3b&scoped=true&"
import script from "./confirm-modal.vue?vue&type=script&lang=ts&"
export * from "./confirm-modal.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-modal.vue?vue&type=style&index=0&id=2d705c3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d705c3b",
  null
  
)

export default component.exports